export class Industry {
    public industry_id: number;
    public name: string;
}
